import styled from "styled-components";

import { Paragraph as BaseParagraph } from "../../components/titles";
import { size } from '../../components/media-queries';
import { FontSize14, FontFamilyBold, FontSize16 } from "../../components/fonts";
import { THEME_COLORS } from "../../styles/theme";
import { ButtonBaseStyle } from "../../components/Buttons/baseStyle";
import { ButtonGradient } from "../../components/Buttons";
import { MarginTop20 } from "../../components/margins";
import { LabelButtonStyle } from "../../components/Buttons/style";

export const Container = styled.div`
    max-width: 935px;
    margin: 0 auto;
`;

export const IconTitleContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 8px 0 10px 0;

    ${props => props.theme.mediaQueries.largeDevices} {
        margin: 44px 0 24px 0;
    }
`;

export const IconTitleDesktop = styled.div`
    display: none;
    ${props => props.theme.mediaQueries.largeDevices} {
        display: block;
    }
`;

export const IconTitleMobile = styled.div`
    display: block;
    ${props => props.theme.mediaQueries.largeDevices} {
        display: none;
    }
`;

export const Title = styled.h2`
    font-size: 42px;
    font-weight: normal;
    margin: 0;
    color: ${props => props.theme.color[THEME_COLORS.darkBlue]};
    ${FontFamilyBold};
    margin-left: 7px;
    font-size: 20px;

    ${props => props.theme.mediaQueries.largeDevices} {
        font-size: 42px;
    }
`;

export const Paragraph = styled(BaseParagraph)`
    margin: 0;
    line-height: 28px;

    margin-bottom: ${props => props.shouldShowImage ? 0 : '80px'};

    & > p {
        margin: 0;
    }

    ${props => props.theme.mediaQueries.largeDevices} {
        margin: ${props => props.shouldShowImage ? '0 0 51px 80px' : '0 0 51px 0px'};
    }
`;

export const ParagraphRegular = styled(BaseParagraph)`
    padding: 0 5px;
    margin-bottom: 20px;

    @media (min-width: ${size.tablet}) {
        text-align: center;
    }
`;

export const DesktopContinueButton = styled.div`
    width: 181px;
    margin: ${props => props.shouldShowImage ? '0 0 0 78px' : '0 auto'};
    display: none;
    ${props => props.theme.mediaQueries.largeDevices} {
        display: block;
    }
`;

// Offer

export const OfferContainer = styled.div`
    border-radius: 35px;
    border: solid 2px rgba(151, 151, 151, 0.6);
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 16px;
    margin-bottom: 80px;

    ${props => props.theme.mediaQueries.largeDevices} {
        max-width: 270px;
        margin-top: 0;
    }
`;

export const OfferMainImage = styled.img`
    
    border-radius: 33px 33px 0 0;
    width: 100%;
    height: auto;
    flex: 0 0 auto;
`;

export const ImageSpacer = styled.div`
    height: 230px;
`;

export const OfferContentContainer = styled.div`
    padding: 0 30px 22px 30px;
    width: 100%;
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

export const DescriptionContainer = styled.div`
    width: 100%;
    color: ${props => props.theme.color.darkBlue};
    ${FontSize14};
    text-align: center;
    flex-grow: 1;
    line-height: 22px;
    margin-top: 8px;

    & > p {
        margin: 0;
    }
`;

export const StampContainer = styled.div`
    width: 116px;
    height: 116px;
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    display: none;

    ${props => props.theme.mediaQueries.largeDevices} {
        display: block;
    }
`;

export const Stamp = styled.div`
    width: 116px;
    height: 116px;
    border-radius: 50%;
    position: relative;
    background: ${props => props.theme.color.greenBlueDiagonal};
    text-align: center;
`;

export const StampInnerCircle = styled.div`
    position: absolute;
    top: 4px;
    left: 4px;
    bottom: 4px;
    right: 4px;
    border-radius: 50%;
    border: 2px solid ${props => props.theme.color.white};
`;

export const StampContentContainer = styled.div`
    padding: 10px;
`;

export const MobileCardHeader = styled.div`
    display: none;
    ${props => props.theme.mediaQueries.largeDevices} {
        display: none;
    }
`;

export const CardHeaderTitle = styled.p`
    ${FontFamilyBold};
    ${FontSize16};
    color: ${props => props.theme.color.white};
    margin: 0;
    text-transform: uppercase;

    ${props => props.theme.mediaQueries.largeDevices} {
        font-size: 13px;
    }
`;

export const CardHeaderIcon = styled.img`
    width: 36px;
    height: 36px;
    margin-right: 11px;

    ${props => props.theme.mediaQueries.largeDevices} {
        margin-right: 0px;
    }
`;

export const Separator = styled.div`
    width: 90px;
    height: 1px;
    opacity: 0.2;
    border: solid 1px #979797;
    background-color: #d8d8d8;
    margin: 23px 0 17px 0;
`;

export const OfferTitle = styled.h2`
    margin: 0;
    ${FontFamilyBold};
    font-size: 26px;
    color: ${props => props.theme.color.darkBlue};
    text-align: center;
    margin-bottom: 8px;
    width: 100%;
`;

export const OfferLink = styled.a`
    display: flex;
    align-items: center;
    padding: 8px;
    text-decoration: none;
    &:hover {
        cursor: pointer;
    }
`;

export const OfferLinkText = styled.p`
    margin: 0;
    color: ${props => props.theme.color.magenta};
    ${FontSize16};
`;

export const RightArrowContainer = styled.div`
    line-height: 0;
    margin-left: 8px;
    top: 4px;
`;

export const MobileContinueButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    position: fixed ;
    bottom: 10px;
    left: 0;
    right: 0;
    z-index: 500;
    ${props => props.theme.mediaQueries.largeDevices} {
        display: none
    }
`;

export const MobileContinueButton = styled.a`
    margin-top: 25px;
    ${ButtonBaseStyle};
    color: white;
    height: 60px;
    font-size: 20px;
    max-width: 160px;
    transition: opacity 0.2 ease-in-out;
    opacity: ${props => props.disabled ? 0.5 : 1};
    border-radius: 0;
`;

export const CallMeButton = styled(ButtonGradient)`
    ${MarginTop20};
`;

export const CallMeLabel = styled(LabelButtonStyle)`
    ${FontSize14};
`;